<template>
  <v-layout>
        <span v-if="getCountdownStatus.count > 0 && !startedTimer">{{prepareTimer()}}</span>

        <v-flex v-if="getCountdownStatus.count > 0" class="flex-grow-1 pa-3 vertically-horizontally-centered">
          <v-progress-linear
            :background-opacity="0.3"
            :buffer-value="100"
            :rounded="true"
            :height="20"
            :value="getCountdownStatus.count/18"
            :color="getColor()"
          ></v-progress-linear>
        </v-flex>

        <v-flex v-if="getCountdownStatus.count > 0" class="border-l pa-3 flex-grow-0">
          {{10 > Math.floor(getCountdownStatus.count/60) ? '0' : ''}}{{Math.floor(getCountdownStatus.count/60)}}:{{10 > (getCountdownStatus.count % 60) ? '0' : ''}}{{getCountdownStatus.count % 60}}
          <v-btn x-small class="ml-3 px-3 py-4 border-radius-lg btn-primary shadow-none" @click="countDownRefresh()"><v-icon class="mr-2" small>update</v-icon>Refresh</v-btn>
        </v-flex>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth'

export default {
  data() {
    return {
      startedTimer: false,
      timer : null,
    }
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer); 
      this.timer = null;
      this.startedTimer = false
    }
  },
  computed: 
    mapGetters([
                'getCountdownStatus',
                'isAdmin'                
            ])
  ,
  methods: {
    prepareTimer() { 
      if (this.startedTimer) return      
      this.startedTimer = true
      this.timer = setInterval(() => { 
        if(this.getCountdownStatus.count <= 0) {
          clearInterval(this.timer); 
          this.timer = null;
          this.startedTimer = false
          this.$store.commit('setFeedback', 'Time limit expired. <br /> Saving disabled')  
        } else {
          this.$store.commit('setCountdownDown')
        }
      }, 1000);
    },
    countDownRefresh() {
        var _refreshAddress = '/refresh-lock2'
        if (this.isAdmin) _refreshAddress = '/refresh-lock'        
        axios.post(_refreshAddress, {task_id : this.getCountdownStatus.id}, this.$store.getters.getAxiosConfig)
        .then(() => {        
          this.$store.commit('setCountdownStatus', {count: 1800, id: this.getCountdownStatus.id, max: 1800})
        })
        .catch(error => {
          var str = error.message            
          var _err = str.substring(str.length - 3, str.length)
          if (_err == 400) this.$store.commit('setFeedback', error.message)   
          if (_err == 401) this.$store.commit('setFeedback', 'You do not have permissions to access to this section.')
          if (_err == 402) this.$store.commit('setFeedback', 'The task was deleted.')
          if (_err == 403) this.$store.commit('setFeedback', 'Your task has been taken over by another user.')           
          this.$store.commit('setCountdownStatus', {count: -1, id: this.getCountdownStatus.id, max: 1800})
        })        
      }, 
      getColor() {
        return this.getCountdownStatus.count > 120? 'light-blue' : 'red'
      }
    }
}
</script>

<style>

</style>